<template>
  <div>
    <section v-if="!disabled" class="btn-group">
      <el-button type="primary" @click="handleAdd">新增单条录入</el-button>
      <el-button @click="handleShowBatchUpload">批量新增录入</el-button>
    </section>
    <el-table :data="data">
      <!-- <el-table-column label="歌单ID" prop="tracklistId"></el-table-column> -->
      <el-table-column label="白名单歌单信息" align="center">
        <el-table-column label="媒体类型" v-slot="{ row }">{{ mediaTypeMap[row.meidaType] }}</el-table-column>
        <el-table-column label="歌曲ID" prop="appealTrackId"></el-table-column>
        <el-table-column label="歌曲/视频名称" prop="trackName" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="歌手名" prop="singerName"></el-table-column>
        <el-table-column label="版本" prop="srcVersion"></el-table-column>
        <el-table-column label="专辑名" prop="albumName"></el-table-column>
        <!-- <el-table-column label="平台" v-slot="{ row }">{{ appealPlatMap[row.appealPlat] }}</el-table-column> -->
        <!-- <el-table-column label="链接" v-slot="{ row }" show-overflow-tooltip>
          <a v-if="row.appealUrl" :href="row.appealUrl" target="_blank">{{ row.appealUrl }}</a>
          <template v-else>-</template>
        </el-table-column> -->
      </el-table-column>
      <el-table-column label="原作品歌曲&视频信息" align="center">
        <el-table-column label="TMEID" prop="originTrackId"></el-table-column>
        <el-table-column label="歌曲/视频名称" prop="originTrackName" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="歌手名" prop="originSingerName"></el-table-column>
        <el-table-column label="版本" prop="originSrcVersion"></el-table-column>
        <el-table-column label="专辑名" prop="originAlbumName"></el-table-column>
        <el-table-column label="词作者" prop="originWordAuthor"></el-table-column>
        <el-table-column label="曲作者" prop="originMusicAuthor"></el-table-column>
        <el-table-column label="权利文件" v-slot="{ row }" show-overflow-tooltip>
          <a v-if="row.rightFile" :href="row.rightFile.fileUrl" :download="row.rightFile.fileName">
            {{ row.rightFile.fileName }}
          </a>
          <template v-else>-</template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        v-if="!disabled"
        label="操作"
        width="120"
        align="center"
        fixed="right"
        v-slot="{ row }"
      >
        <el-button type="text" @click="handleShowEdit(row)">编辑</el-button>
        <span class="divide" />
        <el-button type="text" style="color:red;" @click="handleDel(row)">删除</el-button>
      </el-table-column>
    </el-table>

    <batch-upload-dialog
      :visible.sync="showBatchUpload"
      :mode="TASK_TYPE_ENUM.COMPLAINT"
      :buss-type="LEVEL_ONE_APPEAL.WHITE_LIST.code"
      :need-right="isExternalUser"
      @submit="handleUpload"
    ></batch-upload-dialog>

    <el-dialog
      v-if="showEdit"
      :title="dialogTitle"
      :visible.sync="showEdit"
      width="1060px"
      center
      custom-class="complaint-search-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="handleClose"
    >
      <el-form
        ref="form"
        label-width="130px"
        inline
        :model="form"
        :rules="rules"
      >
        <section class="search-sec">
          <p class="sec-title">白名单歌单信息</p>
          <div class="sub-mod">
            <el-form-item label="媒体类型">
              <el-select
                v-model="form.meidaType"
                style="width:100%"
              >
                <el-option
                  v-for="(item, key) in mediaTypeMap"
                  :key="key"
                  :value="+key"
                  :label="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="歌曲ID">
              <el-input-number
                placeholder="请输入"
                v-model="form.appealTrackId"
                :controls="false"
                clearable
                style="width:185px"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="歌曲/视频名称" prop="trackName">
              <el-input
                placeholder="请输入"
                v-model="form.trackName"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="歌手">
              <el-input
                placeholder="请输入"
                v-model="form.singerName"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="版本">
              <el-input
                placeholder="请输入"
                v-model="form.srcVersion"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="专辑">
              <el-input
                placeholder="请输入"
                v-model="form.albumName"
                clearable
              ></el-input>
            </el-form-item>
            <!-- <el-form-item label="平台">
              <el-select
                v-model="form.appealPlat"
                style="width:100%"
              >
                <el-option
                  v-for="(item, key) in appealPlatMap"
                  :key="key"
                  :value="+key"
                  :label="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="链接">
              <el-input
                placeholder="请输入"
                v-model="form.appealUrl"
                clearable
                style="width:510px"
              ></el-input>
            </el-form-item> -->
          </div>
          <p class="sec-title">原作品歌曲&视频信息</p>
          <div class="sub-mod">
            <el-form-item label="TMEID">
              <el-input-number
                placeholder="请输入"
                v-model="form.originTrackId"
                :controls="false"
                clearable
                style="width:185px"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="歌曲/视频名称" prop="originTrackName">
              <el-input
                placeholder="请输入"
                v-model="form.originTrackName"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="歌手">
              <el-input
                placeholder="请输入"
                v-model="form.originSingerName"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="版本">
              <el-input
                placeholder="请输入"
                v-model="form.originSrcVersion"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="专辑">
              <el-input
                placeholder="请输入"
                v-model="form.originAlbumName"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="词作者">
              <el-input
                placeholder="请输入"
                v-model="form.originWordAuthor"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="曲作者">
              <el-input
                placeholder="请输入"
                v-model="form.originMusicAuthor"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="权利文件" prop="rightFileList">
              <el-upload
                action="/action/upload?type=license"
                :on-remove="handleRightFileRemove"
                :on-error="handleRightFileError"
                :on-success="handleRightFileSuccess"
                :before-upload="handleRightFileBeforeUpload"
                :file-list="form.rightFileList"
                :accept="'.' + rightFileExtType.join(',.')"
              >
                <el-button size="mini" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">支持格式：{{ rightFileExtType.join(',') }}</div>
              </el-upload>
            </el-form-item>
          </div>
        </section>
      </el-form>
      <template #footer>
        <el-button @click="handleClose">关闭</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  TASK_TYPE_ENUM,
  LEVEL_ONE_APPEAL,
} from '../../const'
import basicAddTable from './basicAddTable'

export default {
  name: 'WhiteListAddTable',
  mixins: [basicAddTable],
  methods: {
    handleUpload(fileList, rightFileList) {
      const params = {
        url: fileList[0].url,
        mode: TASK_TYPE_ENUM.COMPLAINT,
        complaintType: LEVEL_ONE_APPEAL.WHITE_LIST.code,
        rightFileList
      }
      this.$emit('upload', params)
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-group {
  margin-bottom: 16px;
}

::v-deep .complaint-search-dialog {
  .el-form {
    .el-form-item__content {
      width: 185px;
    }
  }

  .search-sec {
    padding: 12px 16px;
    background: #FAFAFB;
    border: 1px dashed rgba(0, 0, 0, 0.14);

    &:not(:last-child) {
      margin-bottom: 16px;
    }

    .sec-title {
      color: #002444;
      padding-top: 8px;
      margin-bottom: 8px;
    }
  }
}
</style>
